module.exports = __webpack_public_path__ + "static/media/heart.062213b6.svg";